$(function () {
    var urlMinaSidor = $('#minasidorinloggningurl').data('inloggningsmiljo');
    var urlForetagOmbud = $('#foretagombudinloggningurl').data('inloggningsmiljo');
    var isLoggedInMinaSidor = $('.inloggad-personliga-genvagar').hasClass('inloggadprivat');
    var isLoggedInIK = $('.inloggad-personliga-genvagar').hasClass('inloggadforetag');

    if (isLoggedInMinaSidor) {
        hamtaLoginStatus(urlMinaSidor, visaLoginStatusMinaSidor);
    }
    if (isLoggedInIK) {
        hamtaLoginStatus(urlForetagOmbud, visaLoginStatusForetagOmbud);
    }

    if (!isLoggedInMinaSidor && !isLoggedInIK) {
        uppdaterMobilMenyn();
    }

    function hamtaLoginStatus(url, visaLoginStatusCallback) {
        if (url) {
            $.ajax({
                url: url,
                type: 'GET',
                xhrFields: {withCredentials: true},
                cache: false,
                contentType: 'text/plain'
            }).done(function (data) {
                visaLoginStatusCallback(data);
            }).fail(function () {
                visaEllerDoljInloggadMeny();
            });
        }
    }

    function visaLoginStatusMinaSidor(data) {
        var parent = $('.dropdown.utveckling-minasidor');
        if (data.namn && data.personkundnr) {
            $('.nav-har-barn.hanglas-ms-utloggad').removeClass('hanglas-ms-utloggad').addClass('hanglas-ms-inloggad');
            visaInloggadMenyMinaSidor(data);
            visaInloggadInfo(parent);
            $('a.loginlanklock.loginlank.ms').removeAttr('class');
            $('#minasidor-button-open').addClass('hanglas-oppen-oppnasidor');
        }
    }

    function visaInloggadMenyMinaSidor(data) {
        $('.inloggad-namn').html(data.namn);
        $('.inloggad-kundnummer').html(data.personkundnr);
        $('.menyrad-mintjanstepension').show();
        visaEllerDoljInloggadMeny();
    }

    function visaLoginStatusForetagOmbud(data) {
        var parent = $('.dropdown.utveckling-foretagombud');
        if (data.namn && data.anvandarnummer) {
            $('.nav-har-barn.hanglas-ik-utloggad').removeClass('hanglas-ik-utloggad').addClass('hanglas-ik-inloggad');
            visaInloggadMenyForetagOmbud(data);
            visaInloggadInfo(parent);
            $('a.loginlanklock.loginlank.ms').removeAttr('class');
            $('#foretagombud-button-open').addClass('hanglas-oppen-oppnasidor');
        }
    }

    function visaInloggadMenyForetagOmbud(data) {
        $('.inloggad-namn-ik').html(data.namn);
        $('.inloggad-anvandarnummer').html(data.anvandarnummer);
        $('.menyrad-ik').show();
        visaEllerDoljInloggadMeny();
    }

    function visaEllerDoljInloggadMeny() {
        var namnMinaSidor = $('.inloggad-personliga-genvagar .inloggad-namn').text();
        var namnForetagOmbud = $('.inloggad-personliga-genvagar .inloggad-namn-ik').text();
        var separator = (namnMinaSidor.length && namnForetagOmbud.length) ? ' | ' : '';

        if (namnMinaSidor.length || namnForetagOmbud.length) {
            if (namnMinaSidor === namnForetagOmbud) {
                $('.inloggad-personliga-genvagar .inloggad-namn-ik').hide();
                separator = '';
                return;
            }
            $('.inloggad-separator').html(separator);
            $('.inloggad-personliga-genvagar').show();
        } else {
            $('.inloggad-personliga-genvagar').hide();
        }

        uppdaterMobilMenyn();
    }

    function visaInloggadInfo(parent) {
        parent.find('.hanglas-stangd').removeClass('hanglas-stangd').addClass('hanglas-oppen-oppnasidor');
        parent.find('.minasidor-loggain').hide();
        parent.find('.minasidor-inloggad').show();
    }

    function uppdaterMobilMenyn() {
        visaLoginInfoMobilMinaSidor();
        visaLoginInfoMobilForetagOmbud();
    }

    function visaLoginInfoMobilMinaSidor() {
        var namn = $('.inloggad-personliga-genvagar .inloggad-namn').text();
        var kundnummer = $('.inloggad-personliga-genvagar .inloggad-kundnummer').text();
        if (namn.length && kundnummer.length) {
            $('#minasidor-inloggad .inloggad-namn').html(namn);
            $('#minasidor-inloggad .inloggad-kundnummer').html(kundnummer);
            $('#minasidor-inloggad').show();
            $('#minasidor-loggain').hide();
        } else {
            $('#minasidor-loggain').show();
            $('#minasidor-inloggad').hide();
        }
    }

    function visaLoginInfoMobilForetagOmbud() {
        var namn = $('.inloggad-personliga-genvagar .inloggad-namn-ik').text();
        var anvandarnummer = $('.inloggad-personliga-genvagar .inloggad-anvandarnummer').text();
        if (namn.length && anvandarnummer.length) {
            $('#ik-inloggad .inloggad-namn-ik').html(namn);
            $('#ik-inloggad .inloggad-anvandarnummer').html(anvandarnummer);
            $('#ik-inloggad').show();
            $('#ik-loggain').hide();
        } else {
            $('#ik-loggain').show();
            $('#ik-inloggad').hide();
        }
    }
});
